/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3CanistersNamesRequest = {
  /**
   * Canister IDs
   */
  canisterIds?: Array<string> | undefined;
};

/** @internal */
export const GetApiV3CanistersNamesRequest$inboundSchema: z.ZodType<
  GetApiV3CanistersNamesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  canister_ids: z.array(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "canister_ids": "canisterIds",
  });
});

/** @internal */
export type GetApiV3CanistersNamesRequest$Outbound = {
  canister_ids?: Array<string> | undefined;
};

/** @internal */
export const GetApiV3CanistersNamesRequest$outboundSchema: z.ZodType<
  GetApiV3CanistersNamesRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3CanistersNamesRequest
> = z.object({
  canisterIds: z.array(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    canisterIds: "canister_ids",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3CanistersNamesRequest$ {
  /** @deprecated use `GetApiV3CanistersNamesRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3CanistersNamesRequest$inboundSchema;
  /** @deprecated use `GetApiV3CanistersNamesRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3CanistersNamesRequest$outboundSchema;
  /** @deprecated use `GetApiV3CanistersNamesRequest$Outbound` instead. */
  export type Outbound = GetApiV3CanistersNamesRequest$Outbound;
}

export function getApiV3CanistersNamesRequestToJSON(
  getApiV3CanistersNamesRequest: GetApiV3CanistersNamesRequest,
): string {
  return JSON.stringify(
    GetApiV3CanistersNamesRequest$outboundSchema.parse(
      getApiV3CanistersNamesRequest,
    ),
  );
}

export function getApiV3CanistersNamesRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3CanistersNamesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3CanistersNamesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3CanistersNamesRequest' from JSON`,
  );
}
